$(document).ready(function () {

	document.querySelectorAll('.filter-block').forEach(block => {
		if (block.querySelector('input:checked')) {
			block.setAttribute('open', '');
		}
	});

	// GENERIC CAR TITLE
	$('.generic_car li').each(function(i, li) {
		if ($(li).text().trim().length > 20) {
			$(li).attr('title', $(li).text().trim());
		} 
	});
});
